import { useEffect, useState } from "react";
import Modal from "react-modal";
import { observer } from "mobx-react-lite";

import CreateLicenseModal from "./components/createLicenseModal";
import styles from "./License.module.css";

import licensesStore from "../../stores/licensesStore";
import { Link } from "react-router-dom";

const LicensePage = () => {
  const {
    getLicenses,
    isLoadingLicenses,
    licenses,
    createLicense,
    deleteLicense,
  } = licensesStore;

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedLicenseId, setSelectedLicenseId] = useState(null);

  useEffect(() => {
    getLicenses();
  }, []);

  const handleSubmitCreate = (values) => {
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === "filename" && values.filename) {
        formData.append(key, values.filename);
      } else if (key !== "filename") {
        formData.append(key, values[key]);
      }
    });
    createLicense({
      payload: formData,
      callback: () => setIsOpenModal(!isOpenModal),
    });
  };

  const handleOpenRemoveModal = (id) => {
    setSelectedLicenseId(id);
    setIsOpenDeleteModal(!isOpenDeleteModal);
  };

  const handleCloseRemoveModal = () => {
    setSelectedLicenseId(null);
    setIsOpenDeleteModal(!isOpenDeleteModal);
  };

  const handleSubmitDelete = () => {
    deleteLicense({ id: selectedLicenseId, callback: handleCloseRemoveModal });
  };

  return (
    !isLoadingLicenses && (
      <div className={styles.wrapper}>
        <div className="container-responsive">
          <div className={styles.header}>
            <h4>Licenses</h4>
            <button
              className={styles.blueBtn}
              onClick={() => setIsOpenModal(!isOpenModal)}
            >
              Add License
            </button>
          </div>
          <div className={styles.licensesList}>
            {licenses.map((el, i) => (
              <div key={i} className={styles.license}>
                <Link to={`/license-edit/${el?.id}`}>
                  {el.exp_date} - {el?.insurance_type} -{" "}
                  {el?.license_description}
                </Link>
                <button
                  className={styles.redBtn}
                  onClick={() => handleOpenRemoveModal(el?.id)}
                >
                  delete
                </button>
              </div>
            ))}
          </div>
        </div>
        <CreateLicenseModal
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          onSubmit={handleSubmitCreate}
        />
        <Modal
          isOpen={isOpenDeleteModal}
          onRequestClose={() => handleCloseRemoveModal()}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: "4000",
            },
            content: {
              top: "20%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              zIndex: "130",
              overflow: "auto",
              maxHeight: "80%",
              width: "90%",
              maxWidth: "400px",
            },
          }}
        >
          <div className={styles.modalSubmitWrapper}>
            <span
              onClick={() => handleCloseRemoveModal()}
              className={styles.closeBtn}
            >
              &#x2715;
            </span>
            <h5>Are you sure you want to delete this license?</h5>
            <div className={styles.btnBlock}>
              <button
                onClick={() => handleSubmitDelete()}
                className={styles.blueBtn}
              >
                Delete
              </button>
              <button
                className={styles.redBtn}
                onClick={() => handleCloseRemoveModal()}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  );
};

export default observer(LicensePage);
